// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type AanvragenDomainEntitiesMutatiesoort =
  (typeof AanvragenDomainEntitiesMutatiesoort)[keyof typeof AanvragenDomainEntitiesMutatiesoort];

export const AanvragenDomainEntitiesMutatiesoort = {
  Mutatie: 'Mutatie',
  Royement: 'Royement',
} as const;
